import { assignDefaultValue } from "features/contracting/helpers/contractingFormHelper";
import { PaymentMethodType } from "features/payments/enums/paymentMethodType";
import { Currency } from "features/shared/enums/currency";
import { FormFields } from "features/shared/forms/hooks/useForm";
import { loadModule } from "features/shared/helpers/modules";
import _ from "lodash";

const paymentTypeMap = loadModule<any>("forms/paymentTypeMapping.json");

export const getFormInitValues = (storeValues: FormFields, currency: Currency) => {
  // assign default currency
  let defaultValues = assignDefaultValue(
    storeValues,
    "currency",
    currency
  );

  return defaultValues;
};

export const isSipoPaymentMethod = (formValues: FormFields): boolean => {
  const type: PaymentMethodType = getPaymentMethod(formValues, "depositPaymentTypeCode");
  return type === "Sipo";
};

export const isBankAccountPaymentMethod = (formValues: FormFields): boolean => {
  const depositMethod = getPaymentMethod(formValues, "depositPaymentTypeCode");
  const invoiceMethod = getPaymentMethod(
    formValues,
    "invoicePaymentTypeCode"
  );

  const allowedTypes: string[] = ["BankTransferIncoming", "DirectDebitOrder"];

  return (
    allowedTypes.includes(depositMethod) ||
    allowedTypes.includes(invoiceMethod)
  );
};

export const getPaymentMethod = (
  formValues: FormFields,
  name: string
): PaymentMethodType => {
  return _.get(formValues, name);
};

export const mapPaymentTypeCode = (
  paymentType: string,
  paymentCategory: "Invoice" | "Overpaid"
): string => {
  const paymentCode: string = _.get(
    paymentTypeMap,
    `${paymentType}.${paymentCategory}`
  );

  if (paymentCode === undefined) {
    const error = `Invalid payment type configuration. Combination: ${paymentType}: ${paymentCategory}`;
    console.error(error);
    throw Error(error);
  }

  return paymentCode;
};
